import { mapMutations, mapState, mapGetters } from "vuex";
import { EVENTS } from "@/utils";
import AppDropdown from "@/components/AppDropdown";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import FlexRow from "@/components/FlexRow.vue";
import { SellerFilter, MarketplaceFilter, ProductFilter, SegmentFilter } from "@/components/new-filters";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import NavigationTabs from "@/components/NavigationTabs";
import EmptySegments from "@/components/EmptySegments.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
export default {
  name: "SeoTopSection",
  mixins: [AccountsMixin, LiteTableMixin],
  emits: ["push-submit-modifed-contents", "push-modal", "change-tab"],
  props: {
    hideNavigationTabs: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  components: {
    AppDropdown,
    AppButton,
    AppIcon,
    FlexRow,
    SellerFilter,
    MarketplaceFilter,
    ProductFilter,
    SegmentFilter,
    EmptySegments,
    NavigationTabs
  },
  data() {
    return {
      item: "omny",
      options: [{
        value: "omny",
        text: "Omny"
      }],
      sellers: [],
      push_button_text: {
        default: "Push Selected Updates to Amazon",
        push_mode: this.pushButtonName
      },
      marketplaces_filter_key: ["marketplace_id", "name", "code", "country_code", "id"],
      sellers_filter_key: ["account_id", "name", "region", "id"],
      releasedTabs: [{
        text: "SKU level",
        value: "content_optimisation",
        activeBg: "#D0E2FF",
        activeColor: "#1755AB",
        event: "contentSkuLevelTabOpened"
      }]
    };
  },
  computed: {
    ...mapState({
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      sellers_filter: state => state.content.sellers_filter,
      marketplaces_filter: state => state.content.marketplaces_filter,
      products_filter: state => state.content.products_filter,
      segments_filter: state => state.content.segments_filter,
      currentTab: state => state.seo.currentTabValue,
      tabs: state => state.seo.tabs,
      selected_contents: state => state.content.selected_contents,
      current_mode: state => state.content.current_mode
    }),
    ...mapGetters(["seoGetTab"]),
    tab: {
      async set(value) {
        this.$store.dispatch("seoSetTab", value);
        this.$emit("change-tab");
      },
      get() {
        return this.seoGetTab();
      }
    },
    computedTabs() {
      return this.isOmnyAdmin || this.isOmnyUser ? this.tabs : this.releasedTabs;
    },
    pushButton() {
      return this.push_button[this.current_mode];
    }
  },
  methods: {
    ...mapMutations(["contentsKeyWordListSet", "contentSelectedContentsSet", "contentsKeyWordListSet"]),
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        // Segments are seller-specific; drop the stale selection and refetch.
        this.segments_filter.clearAndApply();
        //this.contentsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_SELLERS_SUB_FILTERS);
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_COUNTRIES, false);
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS);
      }
    },
    async clearSellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.clear();
        // Segments are seller-specific; drop the stale selection and refetch.
        this.segments_filter.clearAndApply();
        //this.contentsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_SELLERS_SUB_FILTERS);
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_COUNTRIES, false);
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        //this.contentsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS);
      }
    },
    async clearMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.clear();
        //this.contentsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS);
      }
    },
    async applyProducts() {
      if (this.products_filter.isModified) {
        this.products_filter.apply();
        //this.contentsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
      }
    },
    async clearProducts() {
      if (this.products_filter.isModified) {
        this.products_filter.clear();
        this.segments_filter.clear();
        this.contentsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
      }
    },
    async applySegments() {
      if (this.segments_filter.isModified) {
        this.segments_filter.apply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching product filters for segments...  ",
          visible: true,
          delay: 50
        });
        // Refetch the listing AND re-init the products filter from the
        // returned (segment-scoped) suggestions, mirroring DashboardFilters'
        // applySegments which refetches the products sub-filter.
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS);
      }
    },
    async searchProducts($event) {
      this.products_filter.searching = true;
      if (Array.isArray($event) && $event.length === 0) {
        this.products_filter.searching = false;
      }
      this.contentsKeyWordListSet($event);
      await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_SUGGESTIONS);
    },
    pushUpdates() {
      //this.current_mode == "push_mode"
      this.selected_contents.length > 0 ? this.handleSubmitContentsMode() : this.handlePushMode();
    },
    handlePushMode() {
      //this.$emit("push-modal");
      if (this.selected_contents.length <= 0) {
        window.$bus.trigger("showWarning", {
          message: "⚠️ Please select desired rows to push to Amazon",
          visible: true,
          delay: 1
        });
      }
    },
    handleSubmitContentsMode() {
      this.$emit("push-submit-modifed-contents");
    }
  }
};